
import { computed, defineComponent, ref } from "vue";
import BananoShape from "@/components/UI/BananoShape.vue";
import AppHeading from "@/components/UI/AppHeading.vue";
import Sign from "@/components/Sign.vue";
import { storeUtil } from "@/store";
import { SignData } from "@/types";

export default defineComponent({
  name: "RemoteSign",
  components: {
    BananoShape,
    AppHeading,
    Sign,
  },

  setup() {
    const accounts = computed(storeUtil.getters.accounts);
    const remoteUrl = ref("");
    const signData = ref<SignData>();
    const index = computed(() =>
      accounts.value.findIndex((acc) => acc.address === signData.value?.address)
    );

    // post ready message
    if (window.opener) window.opener.postMessage("ready", "*");
    window.addEventListener("message", (e) => {
      if (e.data?.metabanSignData) {
        remoteUrl.value = e.origin;
        signData.value = e.data.metabanSignData;
      }
    });

    const onResult = (result: string) => {
      console.log("on result");
      if (window.opener) {
        window.opener.postMessage({ result }, "*");
      }
    };

    return {
      accounts,
      signData,
      remoteUrl,
      index,
      onResult,
    };
  },
});
